var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--mypage"
  }, [_c('v-container', [_c('div', {
    staticClass: "mypage-container"
  }, [_c('mypage-navigation'), _c('div', {
    staticClass: "mypage-contents"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("작품문의내역")])]), _c('div', {
    staticClass: "mypage-contents__body"
  }, [_c('v-data-table', _vm._b({
    staticClass: "v-data-table--default v-data-table--none-border-left",
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: "item.reply",
      fn: function fn(_ref2) {
        var item = _ref2.item,
            value = _ref2.value;
        return [!value ? _c('v-btn', {
          staticStyle: {
            "background-color": "#efefef !important"
          },
          attrs: {
            "to": "/mypage/private-list/".concat(item._id),
            "small": "",
            "outlined": "",
            "width": "80",
            "height": "26",
            "color": "grey-cb"
          }
        }, [_c('span', {
          staticClass: "grey-68--text"
        }, [_vm._v("확인")])]) : _vm._e(), value ? _c('v-btn', {
          attrs: {
            "to": "/mypage/private-list/".concat(item._id),
            "small": "",
            "width": "80",
            "height": "26",
            "color": "primary"
          }
        }, [_vm._v("처리완료")]) : _vm._e()];
      }
    }], null, true)
  }, 'v-data-table', Object.assign({}, _vm.attrs_table, {
    items: _vm.items,
    headers: _vm.headers
  }), false)), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    staticClass: "my-4",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "absolute": "",
      "color": "white",
      "light": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "2",
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)], 1)], 1)])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }